module.exports = __webpack_public_path__ + "img/60076.2446270a.png";